/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts() {
  const webFontLoader = await import(
    /* webpackChunkName: "webfontloader" */ "webfontloader"
  );

  webFontLoader.load({
    google: {
      families: [
        "Nunito:wght@500;600;700;800;900&display=swap",
        "Nunito Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap",
        "Roboto:100,300,400,500,700,900&display=swap",
      ],
    },
  });
}
